// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M7.1 2.65C7.6 2.15 8.4 2.15 8.9 2.65L13.6 7.35C14.01 7.76 13.72 8.45 13.14 8.45H10.95C10.43 8.45 10 8.88 10 9.4V10.5C10 11.05 9.55 11.5 9 11.5H7C6.45 11.5 6 11.05 6 10.5V9.4C6 8.88 5.57 8.45 5.05 8.45H2.86C2.28 8.45 1.99 7.76 2.4 7.35L7.1 2.65Z',
  'M6 14H10',
];
